import e from "../managers/braze-instance.js";
export function removeAllSubscriptions() {
  e.X() && e.removeAllSubscriptions();
}
